import { FetchCities, FetchCompetences, FetchMethods } from "utils/interfaces"
import { nonNullable } from "utils/nonNullable"
import { isBrowser } from "utils/infrastructure/ssg-utils"
import { httpClient } from "utils/infrastructure/httpClient"

function sortCities(data: FetchCities): FetchCities {
    const cities = new Map(data.map((city) => [city.name, city]))
    const collator = new Intl.Collator("ru")
    const names = [...cities.keys()]
        .filter((name) => !["Москва", "Санкт-Петербург"].includes(name))
        .sort((...args) => collator.compare(...args))
    return ["Москва", "Санкт-Петербург", ...names]
        .map((name) => cities.get(name))
        .filter(nonNullable)
}

export async function fetchCities() {
    if (!isBrowser()) return Promise.resolve([])
    const data = await httpClient.get<FetchCities>("cities")
    return sortCities(data)
}

export async function fetchCompetences() {
    if (!isBrowser())
        return {
            groups: [],
            list: [],
        }
    const data = await httpClient.get<FetchCompetences>("competences")
    return {
        groups: data,
        list: data.flatMap(({ competences }) => competences),
    }
}

export async function fetchMethods() {
    if (!isBrowser()) return Promise.resolve([])
    return await httpClient.get<FetchMethods>("methods")
}
